import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import axios from 'axios'          
import '@/assets/tailwind.css'
import 'flowbite'
import { createPinia } from 'pinia'


const tokenFromStorage = localStorage.getItem('token');
if (tokenFromStorage) {
  axios.defaults.headers.common.Authorization = `Bearer ${tokenFromStorage}`;
}

axios.interceptors.response.use(
  r => r,
  err => {
    if (err?.response?.status === 401) {
      localStorage.removeItem('token')
      localStorage.removeItem('user')
      delete axios.defaults.headers.common['Authorization'] 

      if (!router.currentRoute.value.path.startsWith('/login')) { 
        router.replace({
          path: '/login',
          query: { redirect: router.currentRoute.value.fullPath }
        })
      }
    }
    return Promise.reject(err)
  }
);

const saved = localStorage.getItem('token')
if (saved) axios.defaults.headers.common['Authorization'] = `Bearer ${saved}`


createApp(App).use(router).use(createPinia()).mount('#app')
